<template>
  <div id="energy">
    <div class="div-box" style="width:50%;float:left">
      <div class="div-box-title">{{locale('Energy Consumption','能耗')}} ({{locale('tce','吨标煤')}})</div>
      <div style="width:100%;height:100%">
        <div class="div-box-content">
          <span style="font-size:3rem; font-weight:bold;">{{newEnergy[1].Consumption}}</span>
        </div>
        <div class="div-box-content-2">{{locale('MOM','同比')}}</div>
        <div class="div-box-content-2-value">{{newEnergy[1].YearOnYear}}</div>
        <div class="div-box-content-3">{{locale('YOY','环比')}}</div>
        <div class="div-box-content-3-value">{{newEnergy[1].MonthOnMonth}}</div>
      </div>
    </div>
    <div class="div-box" style="width:45%;float:left">
      <div class="div-box-title">{{locale('tce/¥10K','产值能耗')}} {{locale('','(吨/万元)')}}</div>
      <div style="width:100%;height:100%">
        <div class="div-box-content">
          <span style="font-size:3rem; font-weight:bold;">{{newEnergy[2].Consumption}}</span>
        </div>
        <div class="div-box-content-2">{{locale('MOM','同比')}}</div>
        <div class="div-box-content-2-value">{{newEnergy[2].YearOnYear}}</div>
        <div class="div-box-content-3">{{locale('YOY','环比')}}</div>
        <div class="div-box-content-3-value">{{newEnergy[2].MonthOnMonth}}</div>
      </div>
    </div>
    <div class="div-box" style="width:50%;float:left">
      <div class="div-box-title">{{locale('Carbon','碳排放')}} ({{locale('T.CO₂','吨CO₂')}})</div>
      <div style="width:100%;height:100%">
        <div class="div-box-content">
          <span style="font-size:3rem; font-weight:bold;">{{newEnergy[1].Consumption*2.5}}</span>
        </div>
        <div class="div-box-content-2">{{locale('MOM','同比')}}</div>
        <div class="div-box-content-2-value">{{newEnergy[1].YearOnYear}}</div>
        <div class="div-box-content-3">{{locale('YOY','环比')}}</div>
        <div class="div-box-content-3-value">{{newEnergy[1].MonthOnMonth}}</div>
      </div>
    </div>
    <div class="div-box" style="width:45%;float:left">
      <div class="div-box-title">{{locale('Green power','绿色能源')}} (kWh)</div>
      <div style="width:100%;height:100%">
        <div class="div-box-content">
          <span style="font-size:3rem; font-weight:bold;">{{newEnergy[3].Consumption}}</span>
        </div>
        <div class="div-box-content-2">{{locale('MOM','同比')}}</div>
        <div class="div-box-content-2-value">{{newEnergy[3].YearOnYear}}</div>
        <div class="div-box-content-3">{{locale('YOY','环比')}}</div>
        <div class="div-box-content-3-value">{{newEnergy[3].MonthOnMonth}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../utils/request'
import { MONTH_NAME } from "../mainPage/area_bu"

export default {
   name: "energy",
  data() {
    return {
      SaveYear: '',
      CO2: '',
      nowMonth: [],
      newEnergy: [{
      Consumption: '',
      YearOnYear: '',
      MonthOnMonth: ''
      },
      {
     Consumption: '',
      YearOnYear: '',
      MonthOnMonth: ''
      },
      {
      Consumption: '',
      YearOnYear: '',
      MonthOnMonth: ''
      },
      {
      Consumption: '',
      YearOnYear: '',
      MonthOnMonth: ''
      }
      ],
      queryParams: {
        QueryStartMonth: "11",
        QueryYear: 2020
      }
    };
  },
  methods: {
    refreshData(value) {
      console.log("value",value);
      const { refreshChart, refreshGreenPower } = this;
      if (value === undefined) {
        value = this.queryParams
      } else {
        this.queryParams = value
      }
      request({
        url: 'GetBscData/GetEnergyValue',
        method: 'post',
        data: this.queryParams
      }).then(response => {
        const res = response
        console.log(res)
        let chartData = []
        try {
          chartData = res.data
           console.log(chartData)
          this.newEnergy=chartData.data
          this.nowMonth=chartData.SaveMonth[0]
          this.SaveYear=chartData.SaveYear
          console.log("kaishi----")
          console.log(this.nowMonth)
          console.log(this.SaveYear)
         this.$parent.$parent.setYearAndMonth(this.nowMonth,this.SaveYear)
          refreshGreenPower()
        } catch {
        }
      })
    },
    createData() {
      const { randomExtend } = this;
      this.digitalFlopData = {
      Consumption: '',
      YearOnYear: '',
      MonthOnMonth: ''
      }
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10);
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      }
    },
    refreshGreenPower(queryParam) {
      this.selectedYear = ''
      var queryArgs = {}
      if (queryParam != undefined) {
        queryArgs = queryParam
      } else {
        queryArgs = {
          QueryYear: this.SaveYear,
          QueryStartMonth: this.nowMonth
        }
      }
      request({
        url: 'Kanban/GetGreenPower',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        var vData = res.data.Data
        if (vData != undefined && vData.length > 0) {
          this.newEnergy.push({
            Consumption: vData[0],
            YearOnYear: vData[1],
            MonthOnMonth: vData[2]
          })
        }
      })
    }
  },
  mounted() {
    const { createData, refreshData } = this;

    createData();

    setInterval(createData, 30000);

    refreshData();
  }
};
</script>
<style lang="less">
#energy {
  position: relative;
  width: 100%;
  height: 20%;
  background-color: #17293d;
  box-sizing: border-box;
  padding-bottom: 3px;
  padding-top: 20px;

  .div-box {
    position: relative;
    height: 100%;
    float: left;
    margin-left: 10px;
    margin-bottom: 10px;
    background-color: #3A4C7E;
  }

  .div-box-title {
    height: 30px;
    text-align: left;
    margin-left: 20px;
    margin-top: 10px;
  }
  .div-box-content {
    width: 80%;
    text-align: left;
    position: absolute !important;
    top: 40% !important;
    height: 76px;
    margin-left: 20px;
    transform: translateY(-0%);
  }
  .div-box-content-2 {
    width: 80%;
    text-align: right;
    position: absolute !important;
    top: 20% !important;
    right: 25%;
    transform: translateY(-0%);
  }
  .div-box-content-2-value {
    width: 80%;
    text-align: right;
    vertical-align: middle;
    position: absolute !important;
    top: 23% !important;
    right: 10%;
    transform: translateY(-0%);
  }
  .div-box-content-3 {
    width: 80%;
    text-align: right;
    position: absolute !important;
    top: 60% !important;
    right: 25%;
    transform: translateY(-0%);
  }
  .div-box-content-3-value {
    width: 80%;
    text-align: right;
    position: absolute !important;
    top: 63% !important;
    right: 10%;
    transform: translateY(-0%);
  }
}
</style>
